// BookingListContainer.jsx
import React from 'react';
import { Grid, Box, Button, useTheme, useMediaQuery, Typography } from '@mui/material';
import NoResultsPlaceholder from 'components/organisms/noResultsPlaceholder/view';
import BookingDesktopView from './bookingDesktopView';
import BookingMobileView from './bookingMobileView';
import BookingPagination from './bookingPagination';
import BookingListSkeleton from './bookingListSkeleton';
import {
  Warning,
} from '@mui/icons-material';

const BookingListContainer = ({
  bookings,
  filters,
  setFilters,
  handleSortChange,
  handlePageChange,
  navigateBooking,
  statusMapping,
  paginationInfo,
  t,
  bookingAction,
  bookingLoaded,
  pendingBookings,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const typeMapping = {
    'MR': 'Meeting Room',
    'HD': 'Hot Desk',
    'PR': 'Private Office',
  };

  return (
    <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: { xs: '12px', md: '25px' } }}>
      <Grid item xs={12} md={12} sx={{ paddingTop: 5 }}>
        {!bookingLoaded && (
          <BookingListSkeleton />
        )}
        {bookingLoaded && pendingBookings && pendingBookings.length > 0 && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' }, // Stack on mobile, row on desktop
              alignItems: { xs: 'stretch', sm: 'center' }, // Stretch on mobile, center on desktop
              gap: 2,
              backgroundColor: 'danger.light',
              padding: '12px 16px',
              borderRadius: '8px',
              marginBottom: 3,
              border: '1px solid',
              borderColor: 'danger.main',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                flex: 1,
              }}
            >
              <Warning
                color="danger"
                sx={{
                  marginRight: 2,
                  fontSize: '24px'
                }}
              />
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 500,
                    color: 'warning.dark',
                    marginBottom: '2px'
                  }}
                >
                  {t('Pending Bookings')}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: 'warning.dark' }}
                >
                  {t('You have')} {pendingBookings.length} {t('booking(s) pending confirmation')}
                </Typography>
              </Box>
            </Box>
            <Button
              variant="outlined"
              color="danger"
              onClick={() => {
                setFilters({
                  ...filters,
                  status: 'PC',
                  date: '',
                  code: '',
                });
              }}
              sx={{
                borderRadius: '20px',
                minWidth: '120px',
                alignSelf: { xs: 'stretch', sm: 'auto' }, // Full width on mobile
                mt: { xs: 1, sm: 0 }, // Add margin top only on mobile
              }}
            >
              {t('Review Now')}
            </Button>
          </Box>
        )}
        {bookingLoaded && bookings?.length === 0 && (
          <NoResultsPlaceholder
            firstSentence={t('No bookings found')}
            lastSentence={t('')}
          />
        )}

        {bookingLoaded && bookings?.length > 0 && (
          <>
            {isMobile ? (
              <BookingMobileView
                bookings={bookings}
                navigateBooking={navigateBooking}
                statusMapping={statusMapping}
                typeMapping={typeMapping}
                bookingAction={bookingAction}
                t={t}
              />
            ) : (
              <BookingDesktopView
                bookings={bookings}
                filters={filters}
                handleSortChange={handleSortChange}
                navigateBooking={navigateBooking}
                statusMapping={statusMapping}
                typeMapping={typeMapping}
                t={t}
                bookingAction={bookingAction}
                pendingBookings={pendingBookings}
              />
            )}
            <BookingPagination
              paginationInfo={paginationInfo}
              handlePageChange={handlePageChange}
              t={t}
            />
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default BookingListContainer;